import { Button, Tag } from 'antd'
import clsx from 'clsx'
import { FC, useState } from 'react'

import styles from '../company-config.module.scss'
import { CompanyEmployeesConfig } from '../constants/company-config'
import { CompanyEmployeesConfigType } from '../types/company-config'

type CompanyConfigEmployeesComponentProps = {
  majorText: string
  minorText: string
  noteText: string
  initialState?: string
  onStateChange: (state: CompanyEmployeesConfigType) => void
  error: string | undefined
}

export const CompanyConfigEmployeesComponent: FC<CompanyConfigEmployeesComponentProps> = ({
  majorText,
  minorText,
  noteText,
  initialState,
  onStateChange,
  error,
}: CompanyConfigEmployeesComponentProps) => {
  const [state, setState] = useState<CompanyEmployeesConfigType | undefined>(initialState ? JSON.parse(initialState) : undefined)

  const handleStateChange = (state: CompanyEmployeesConfigType) => {
    setState(state)
    onStateChange(state)
  }

  return (
    <div className="col-12 col-lg-12">
      <div className="row g-0 gap-2 align-items-center bg-white rounded-4 pb-5 pt-4 px-3 px-md-5 mb-3">
        <div className={clsx(styles.config, 'd-flex flex-column justify-content-center col-12 col-md mb-1 mb-sm-0')}>
          <span className={styles.configTextMajor}>{majorText}</span>
          <span className={styles.configTextMinor}>{minorText}</span>
        </div>
        <div className="d-flex flex-wrap flex-sm-nowrap col-12 col-md">
          {CompanyEmployeesConfig.map((companyEmployees, index) => (
            <Button
              key={index}
              className={clsx('ms-2 mb-1', {
                ['ant-btn-color-primary']: JSON.stringify(state) == JSON.stringify(companyEmployees),
              })}
              onClick={() => handleStateChange(companyEmployees)}
              size="large"
            >
              {companyEmployees.min}
              {companyEmployees.max ? ` - ${companyEmployees.max}` : null}
            </Button>
          ))}
        </div>
        <div className={clsx(styles.configEmployeesNoteWrap, 'col-12 col-md')}>
          <Tag
            className="p-2"
            color="#D4DAED"
          >
            {noteText}
          </Tag>
          {error ? <div className={clsx(styles.configErrorMessage, 'mt-2')}>{error}</div> : null}
        </div>
      </div>
    </div>
  )
}
